import Container from "../common/Container";
import SectionLabel from "../common/SectionLabel";
import SocialIcon from "../common/SocialIcon";
import { contactLinks } from "../../data/portfolioData";

const Contact = () => {
  return (
    <section id="contact" className="contact-section">
      <Container>
        <SectionLabel number="04" label="Contact" />

        <h2 className="contact-headline">
          Let's build
          <br />
          something <span>great.</span>
        </h2>

        <p className="contact-sub">
          Interested in building thoughtful digital products, collaborating with
          great teams, while discussing frontend architecture, performance and
          UX.
        </p>

        <div className="contact-links">
          {contactLinks.map((link) => (
            <a
              href={link.href}
              className="contact-link"
              key={link.label}
              target={link.external ? "_blank" : undefined}
              rel={link.external ? "noopener noreferrer" : undefined}
            >
              <SocialIcon type={link.icon} />
              {link.label}
            </a>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Contact;
